import React, { useState, useCallback, useEffect } from "react";
import ResourcesService from '@/services/ResourcesService';

export default function useResourceData() {
  const limit = 1000;
  const sortColumn = "_id";
  const sortDirection = "desc";
  const searchQuery = {};

  // Data State
  const [data, setData] = useState([]);
  
  // UI State
  const [loading, setLoading] = useState(true);
  
  const [removing, setRemoving] = useState(false);
  const [creating, setCreating] = useState(false);
  const [updating, setUpdating] = useState(false);

  const [error, setError] = useState(null);
  
  // Pagination State
  const [totalCount, setTotalCount] = useState(0);
  
  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await ResourcesService.getWithFilters({ limit, sortColumn, sortDirection, filters: searchQuery });
    
    if (result.error) {
      setError(result.error); setData([]); setTotalCount(0);
    } else {
      setData(result.data); setTotalCount(result.totalCount);
    }
    
    setLoading(false);
  }, []);

  // Add this useEffect for automatic loading
  useEffect(() => {
    loadData();
  }, [loadData]);

  const clearError = useCallback(() => { setError(null);}, []);

  const create = async (newRecord) => {
    setCreating(true);
    setError(null);
    const result = await ResourcesService.create(newRecord);
    if (result.error) {
      setError(result.error);
      setCreating(false);
      return false;
    } else {
      await loadData();
      setCreating(false);
      return true;
    }
  }

  const remove = async (id) => {
    setRemoving(true);
    setError(null);
    const result = await ResourcesService.delete(id);
    if (result.error) {
      setError(result.error);
      setRemoving(false);
      return false;
    } else {
      await loadData();
      setRemoving(false);
      return true;
    }
  }

  const update = async (id, updatedRecord) => {
    setUpdating(true);
    setError(null);
    const result = await ResourcesService.update(id, updatedRecord);
    if (result.error) {
      setError(result.error);
      setUpdating(false);
      return false;
    } else {
      await loadData();
      setUpdating(false);
      return true;
    }
  }

  return {
    data,
    totalCount,
    
    loading, creating, updating, removing,
    setLoading, setCreating, setUpdating, setRemoving,
    error, clearError,
    
    sortColumn,
    sortDirection,
    limit,

    loadData, create, remove, update
  };
}